export default __webpack_public_path__ + "static/media/slew_blue.af53a3ca.svg";